import { TGlobalStore } from '..'
import type { StoreApi } from 'zustand'

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed'

const getInitialCollapsedState = (): boolean => {
  if (typeof window === 'undefined') return false
  const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
  return stored === 'true'
}

export interface ISidebarState {
  isSidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

const sidebarSlice = (set: StoreApi<TGlobalStore>['setState']): ISidebarState => ({
  isSidebarCollapsed: getInitialCollapsedState(),
  toggleSidebar: () =>
    set(state => {
      const newValue = !state.isSidebarCollapsed
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(newValue))
      return { ...state, isSidebarCollapsed: newValue }
    }),
  setSidebarCollapsed: (isSidebarCollapsed: boolean) =>
    set(state => {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isSidebarCollapsed))
      return { ...state, isSidebarCollapsed }
    }),
})

export default sidebarSlice
